<div class="oauth-container">
  <div class="content">

    <!-- Processing State -->
    @if (isProcessing()) {
      <div class="processing-section">
        <h2>{{ processingMessage() }}</h2>
        <div class="spinner"></div>
        <p class="processing-hint">{{ processingHint() }}</p>
      </div>
    }

    <!-- Authenticated State -->
    @if (isAuthenticated() && !isProcessing()) {
      <div class="authenticated-section">
        <div class="success-icon">✓</div>
        @if (showActions()) {
          <h2>Sign Out</h2>
          <p class="success-message">Are you sure you want to sign out?</p>
        } @else {
          <h2>Authentication Successful</h2>
          <p class="success-message">You have been successfully authenticated.</p>
        }

        @if (showActions()) {
          <div class="actions">
            <button (click)="logout()" class="action-button secondary">
              Sign Out
            </button>
            <button (click)="cancel()" class="action-button secondary">
              Cancel
            </button>
          </div>
        }
      </div>
    }

    <!-- Error State -->
    @if (hasError() && !isProcessing()) {
      <div class="error-section">
        <div class="error-icon">⚠</div>
        <h2>Authentication Failed</h2>
        <div class="error-details">
          <p class="error-type">{{ errorName() }}</p>
          <p class="error-message">{{ errorMessage() }}</p>
        </div>
        <div class="actions">
          <button (click)="retry()" class="action-button primary">
            Try Again
          </button>
          <button (click)="cancel()" class="action-button secondary">
            Cancel
          </button>
        </div>
      </div>
    }

  </div>
</div>
